import styled from 'styled-components';

const BoldLabel = styled.div`
  font-weight: bold;

  &.blue {
    color: #0C8ED7;
  }

  &.capitalize {
    text-transform: capitalize;
  }
`;

export default BoldLabel;
